/**
 * Basic bulk edit validation constants and helpers.
 * Use for limits and rules that apply when opening or submitting the bulk edit modal.
 */

import type { FieldSchemaConfig } from '../types';

/** Maximum number of styles that can be bulk edited at once (block or warn when exceeded). */
export const maxBulkEditSelection = 200;

/** Maximum number of items that can be bulk edited at once (block or warn when exceeded). */
export const maxItemsBulkEditSelection = 50;

/**
 * Default validation config per field type.
 * Views can override these by setting validation options on the column.
 */
export const defaultValidationConfig: Record<string, Partial<FieldSchemaConfig>> = {
  text: {
    maxChar: 100,
  },
  description: {
    maxChar: 500,
  },
  number: {
    allowedDecimals: 2,
  },
  // dd, date, multiselect, status, boolean have no defaults (add as needed)
};

/**
 * Merge default validation config with column-level config.
 * Column config takes precedence (overrides defaults).
 */
export function mergeWithDefaults(col: FieldSchemaConfig): FieldSchemaConfig {
  const type = col.type ?? 'text';
  const defaults = defaultValidationConfig[type] ?? {};
  return { ...defaults, ...col };
}
